export default {
  GET_TEMPLATE_LIST_REQUEST: 'GET_TEMPLATE_LIST_REQUEST',
  GET_TEMPLATE_LIST_SUCCESS: 'GET_TEMPLATE_LIST_SUCCESS',
  GET_TEMPLATE_LIST_FAILURE: 'GET_TEMPLATE_LIST_FAILURE',

  GET_TEMPLATE_DETAILS_REQUEST: 'GET_TEMPLATE_DETAILS_REQUEST',
  GET_TEMPLATE_DETAILS_SUCCESS: 'GET_TEMPLATE_DETAILS_SUCCESS',
  GET_TEMPLATE_DETAILS_FAILURE: 'GET_TEMPLATE_DETAILS_FAILURE',

  CLEAR_TEMPLATE_DETAILS: 'CLEAR_TEMPLATE_DETAILS',

  UPDATE_TEMPLATE_REQUEST: 'UPDATE_TEMPLATE_REQUEST',
  UPDATE_TEMPLATE_SUCCESS: 'UPDATE_TEMPLATE_SUCCESS',
  UPDATE_TEMPLATE_FAILURE: 'UPDATE_TEMPLATE_FAILURE',
};



// WEBPACK FOOTER //
// ./src/store/types/templateTypes.js